// import React from 'react';
//   import SEO from '../components/SEO';
//   import { MODULES } from '../constants';
//   import GlowCard from '../components/GlowCard';
//   import FAQSection from '../components/FAQSection';
//   import AIImage from '../components/AIImage';
//   import ImageCarousel, { usePublicImages } from '../components/ImageCarousel';

//   const LMSPage: React.FC = () => {
//     const moduleData = MODULES.find(m => m.id === 'lms')!;

//     const lmsFAQ = [
//       {
//         question: "Can we track ATCO competency within the LMS?",
//         answer: "Yes. AviaGov LMS includes specialized competency frameworks for ATCOs, instructors, and other regulated personnel, including unit endorsements and medical rating tracking."
//       },
//       {
//         question: "Does the platform support SCORM or xAPI?",
//         answer: "Yes, our LMS is fully compliant with modern e-learning standards, allowing you to import your existing aviation courseware."
//       },
//       {
//         question: "How are exams secured?",
//         answer: "We offer randomized question banks and optional browser-lockdown proctoring for high-stakes certification exams, aligned with organizational and authority policies."
//       }
//     ];

//     const lmsCarouselImages = usePublicImages('lms', 'LMS interface screen');

//     return (
//       <div className="animate-fade-in-up">
//         <SEO
//           title="Aviation Training & LMS"
//           description="Aviation Learning Management System for operators,
//   training organizations, and authorities, providing regulator-ready training
//   records, competency traceability, and audit-supporting certification
//   management."
//           ogType="product"
//           faq={lmsFAQ}
//         />

//         <section className="py-24 bg-slate-950 border-b border-white/5">
//           <div className="max-w-7xl mx-auto px-4 grid grid-cols-1 lg:grid-cols-2
//   gap-16 items-center">
//             <div>
//               <nav className="flex items-center space-x-2 text-slate-500 text-sm
//   mb-6 uppercase tracking-widest">
//                 <span>Modules</span>
//                 <span>/</span>
//                 <span className="text-accent">LMS</span>
//               </nav>
//               <h1 className="text-5xl lg:text-7xl font-bold font-heading mb-8
//   leading-tight">
//                 Certify with <br />
//                 <span className="text-accent">Confidence.</span>
//               </h1>
//               <p className="text-xs uppercase tracking-widest text-slate-500 mb-
//   6">
//                 Compliance-Grade Training & Competency Management
//               </p>
//               <p className="text-xl text-slate-400 mb-10 leading-relaxed">
//                 The aviation industry demands precise training records. AviaGov
//   LMS manages the entire lifecycle of personnel competence, from initial training
//   to license renewal.
//               </p>
//               <p className="text-sm text-slate-500 mb-4 leading-relaxed">
//                 Designed for airlines, operators, training organizations (ATO/
//   DTO), and authorities requiring regulator-ready training records, competency
//   traceability, and defensible certification management.
//               </p>
//               <p className="text-sm text-slate-500 mb-4 leading-relaxed">
//                 When used with AviaGov SMS, training actions triggered by safety
//   findings produce auditable evidence and certificates that feed back into the
//   SMS as mitigation and safety promotion records.
//               </p>
//               <p className="text-sm text-slate-500 mb-4 leading-relaxed">
//                 Organizations may also enable a controlled public training
//   portal under their own domain, without compromising governance or oversight.
//               </p>
//             </div>
//             <div className="grid grid-cols-2 gap-4">
//               {moduleData.metrics?.slice(0, 2).map((metric, i) => (
//                 <div key={i} className="bg-white/5 border border-white/10 p-8
//   rounded-2xl text-center">
//                   <div className="text-4xl font-bold text-white mb-
//   2">{metric.value}</div>
//                   <p className="text-xs text-slate-400 uppercase">{metric.label}
//   </p>
//                 </div>
//               ))}
//               <div className="col-span-2 relative p-1 bg-slate-800 rounded-2xl
//   overflow-hidden border border-white/10">
//                 <AIImage
//                   src="/publicLms.png"
//                   alt="AviaGov LMS interface preview"
//                   className="w-full opacity-95"
//                   aspectRatio="4:3"
//                 />
//               </div>
//             </div>
//           </div>
//         </section>

//         <section className="py-24 px-4 border-b border-white/5">
//           <div className="max-w-7xl mx-auto">
//             <h2 className="text-3xl font-bold font-heading mb-6 text-white">How
//   Training Works in AviaGov</h2>
//             <p className="text-slate-400 text-base mb-8 leading-relaxed">
//               In AviaGov LMS, training flows from course authoring to
//   certification: courses are created, learners are enrolled, competence is
//   assessed, certificates are issued and verified, and evidence is retained for
//   audits and regulatory oversight.
//             </p>
//             <p className="text-sm text-slate-500 mb-8 leading-relaxed">
//               AviaGov LMS issues digitally verifiable certificates that can be
//   revoked, renewed, and audited, providing organizations and authorities with
//   confidence in training outcomes.
//             </p>
//             <p className="text-sm text-slate-500 mb-8 leading-relaxed">
//               AviaGov LMS maintains complete training, examination, and
//   certification histories, supporting internal audits, authority oversight, and
//   regulatory inspections.
//             </p>
//             <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
//               {moduleData.features.map((feature, i) => (
//                 <GlowCard key={i} delay={i * 100}>
//                   <h3 className="text-xl font-bold text-white mb-
//   4">{feature.title}</h3>
//                   <p className="text-slate-400 text-sm">{feature.description}</
//   p>
//                 </GlowCard>
//               ))}
//             </div>
//           </div>
//         </section>

//         <ImageCarousel
//           title="LMS Interface Preview"
//           description="Screens from the LMS workspace, competency tracking, and certification views."
//           images={lmsCarouselImages}
//         />

//         <section className="py-12 px-4">
//           <GlowCard className="max-w-7xl mx-auto">
//             <h2 className="text-3xl font-bold font-heading mb-12 text-
//   white">Optional External Training Access</h2>
//             <p className="text-sm text-slate-500 leading-relaxed">
//               Organizations may optionally grant controlled access to selected
//   training content for external users such as contractors, partners, or third
//   parties. Access rules, pricing, certification scope, and visibility remain
//   fully under organizational control, and AviaGov does not publish or promote
//   training content.
//             </p>
//           </GlowCard>
//         </section>

//         <FAQSection items={lmsFAQ} title="Aviation Training FAQ" />
//       </div>
//     );
//   };

//   export default LMSPage;
import React from 'react';
import { Link } from 'react-router';
import SEO from '../components/SEO';
import { MODULES } from '../constants';
import GlowCard from '../components/GlowCard';
import FAQSection from '../components/FAQSection';
import AIImage from '../components/AIImage';
import ImageCarousel, { usePublicImages } from '../components/ImageCarousel';

const LMSPage: React.FC = () => {
  const moduleData = MODULES.find(m => m.id === 'lms')!;

  // Enhanced FAQ with rich schema support
  const lmsFAQ = [
    {
      question: "Can AviaGov support ATCO objective management?",
      answer: "Yes. AviaGov includes ATCO framework packs, objective catalogs, objective mapping into training structures, and evidence-aware evaluation so regulated objective tracking can sit alongside course delivery and governed qualification records."
    },
    {
      question: "What training delivery formats does the LMS support?",
      answer: "The LMS supports course catalogs, lessons, assessments, enrollments, certificates, live sessions, and activity models for SCORM/xAPI, documents, slides, and other structured training content within governed training programs."
    },
    {
      question: "How are assessments and checks controlled?",
      answer: "AviaGov supports structured assessments, evidence capture, audit trails, airline check events and debriefs, and assessor-authority-based finalization for organizations that need controlled qualification decisions and defensible training records."
    },
    {
      question: "What are compliance packs in AviaGov LMS?",
      answer: "Compliance packs are seeded overlays that activate governance presets, training structures, and export-ready record profiles. Current packs such as the ICAO baseline pack, the EASA pack with Part-FCL, Part-MED, Part-ARA, Part-ORA, and AMC/GM mapping, and the FAA pack for broader airline commercial expansion help structure deployments, but they should not be treated as regulator-signed jurisdiction packs."
    },
    {
      question: "Can airline training records include imported external events?",
      answer: "Yes. AviaGov airline training workflows support external provider imports, application of imported events into qualification records, recurrence alerts, qualification decision review, compliance queues, and export-ready airline training record structures."
    },
    {
      question: "Do you offer a public training portal for external learners?",
      answer: "Yes. Organizations can enable a controlled public training portal on their own domain for catalog access, enrollment, learner progress, and certificates while keeping governance, qualification records, and visibility under organizational control."
    }
  ];

  // Trust signals / Positioning
  const trustSignals = [
    { icon: "🧭", label: "Governed qualification records", description: "Training evidence tied to qualification outcomes" },
    { icon: "🛫", label: "Airline and ATCO specialization", description: "Operational layers beyond generic LMS delivery" },
    { icon: "🗂️", label: "Compliance-pack activation", description: "Seeded overlays, presets, and export profiles" },
    { icon: "🔗", label: "Portal, analytics, and workflow links", description: "Delivery connected to operational governance" }
  ];

  const productLayers = [
    {
      title: "LMS Delivery",
      description: "The delivery layer covers catalogs, lessons, assessments, enrollments, certificates, learner portals, analytics, and live sessions for regulated training operations.",
      items: ["Course catalog and learner flows", "SCORM/xAPI, document, slides, and live session activity types", "Certificates and portal under customer domain", "Analytics and learner risk visibility"]
    },
    {
      title: "Training Governance",
      description: "Governance adds qualification programs, recurrence policies, qualification records, assessor authorities, export profiles, and compliance-pack activation.",
      items: ["Qualification programs and recurrence management", "Governed qualification records", "Assessor authority controls", "Export-ready training record structures"]
    },
    {
      title: "ATCO Objectives",
      description: "ATCO specialization introduces framework packs, objective catalogs, objective mapping, and evidence-aware evaluation for objective-driven training environments.",
      items: ["ATCO framework packs", "Objective catalogs and mapping", "Evidence-aware evaluation", "Qualification linkage from training evidence"]
    },
    {
      title: "Airline Ops Training",
      description: "Airline workflows extend the platform with crew qualification profiles, imported provider evidence, check events, decision controls, and compliance queues.",
      items: ["Crew profiles across role, rank, base, and fleet", "External provider imports and qualification application", "Check events, debriefs, and decision workflow", "Recurrence alerts, compliance queue, and export packs"]
    }
  ];

  const governedWorkflow = [
    {
      num: "1",
      title: "Deliver training",
      desc: "Publish governed courses, live sessions, and assessments through the LMS delivery layer, with catalog, enrollment, learner progress, certificates, and customer-domain portal access where needed."
    },
    {
      num: "2",
      title: "Define qualification and recurrence",
      desc: "Configure qualification programs, recurrence policies, qualification records, and assessor authorities so training outcomes feed a governed qualification model instead of a standalone course history."
    },
    {
      num: "3",
      title: "Apply airline or ATCO specialization",
      desc: "Activate ATCO objective structures or airline operational workflows depending on the training environment, including objective mapping, crew qualification profiles, and specialized review paths."
    },
    {
      num: "4",
      title: "Ingest evidence and finalize checks",
      desc: "Capture assessment evidence, import external training activity, run airline check events and debriefs, and finalize qualification decisions through assessor-authority-based controls."
    },
    {
      num: "5",
      title: "Monitor alerts and export records",
      desc: "Track recurrence alerts, learner risk, and compliance queues, then produce export-ready record structures and profiles for internal oversight, operators, and authorities."
    }
  ];

  const airlineWorkflows = [
    {
      title: "Crew qualification profiles",
      description: "Maintain crew records with employee number, role, rank, base, fleet assignments, license records, and medical certificates."
    },
    {
      title: "External training imports",
      description: "Import training events from CAE-like or other providers and route them into governed review paths rather than leaving them as disconnected evidence."
    },
    {
      title: "Check events and debriefs",
      description: "Record airline check events, debrief outcomes, and supporting evidence as part of controlled qualification history."
    },
    {
      title: "Assessor authority controls",
      description: "Use assessor-authority-based finalization so qualification decisions follow defined authority boundaries."
    },
    {
      title: "Recurrence and compliance monitoring",
      description: "Run recurrence alerts, qualification decision review, and compliance queues for expiring or incomplete crew requirements."
    },
    {
      title: "Export-ready airline records",
      description: "Produce airline export record packs and structured histories for downstream review, record retention, and operational handoff."
    }
  ];

  const atcoCapabilities = [
    "ATCO framework packs and seeded structure overlays",
    "Objective catalogs and mapping into lessons, assessments, and training programs",
    "Evidence-aware evaluation across governed training records",
    "Qualification linkage between objective evidence, recurrence, and oversight workflows"
  ];

  const compliancePacks = [
    "ICAO baseline pack",
    "EASA pack using Part-FCL, Part-MED, Part-ARA, Part-ORA, and AMC/GM mapping",
    "FAA pack for broader airline commercial expansion"
  ];

  const whatsInside = [
    {
      title: 'Training governance workspace',
      description: 'Run qualification programs, recurrence policies, qualification records, assessor authorities, export profiles, and compliance-pack activation from a dedicated operational workspace rather than a marketing concept.',
    },
    {
      title: 'Operational analytics and attention queues',
      description: 'Track at-risk learners, compliance exceptions, learner 360 views, grading pressure, certificate health, qualification alerts, and delivery mix from analytics surfaces designed for training operations teams.',
    },
    {
      title: 'Cohorts and batch-run delivery',
      description: 'Manage enrollment deadlines, seat limits, timezone-aware scheduling, recurring live-session generation, cohort calendars, and segment-aware delivery rules for structured course runs.',
    },
    {
      title: 'Assessment and gradebook depth',
      description: 'Use question banks, rubric templates, weighted grading, grade overrides, finalization states, bulk grade operations, and CSV or Excel-ready exports across governed assessment workflows.',
    },
    {
      title: 'First-party live delivery',
      description: 'Support serious live operations with first-party meeting delivery, moderator controls, attendance evidence, recordings, reminder flows, and mobile-friendly meeting access for operational learners.',
    },
    {
      title: 'Blueprints, compliance authoring, and integrations',
      description: 'Extend the LMS with blueprint courses, outbound webhooks, curriculum compliance authoring, AI generation drafts, and governed certificate or template tooling.',
    }
  ];

  const deliveryDepth = [
    'Question bank, rubric templates, and reusable assessment tooling',
    'Weighted grading, grade overrides, finalization states, and bulk grade operations',
    'Cohort calendars, recurring live-session generation, and segment-aware delivery rules',
    'Attendance evidence, reminder notifications, recordings, and public workshop style delivery',
    'Blueprint courses, webhook integrations, curriculum compliance authoring, and AI draft support'
  ];

  const rolePages = [
    {
      title: 'For ANSPs and CAAs',
      description: 'ATCO objective structures, qualification governance, recurrence, and authority-ready evidence across oversight-driven environments.',
      path: '/lms-ansp-caa',
    },
    {
      title: 'For Airlines',
      description: 'Crew qualification profiles, external provider imports, check-event control, recurrence alerts, and export-ready airline records.',
      path: '/lms-airlines',
    },
    {
      title: 'For Aviation Companies',
      description: 'Controlled training delivery, qualification evidence, certificates, and optional branded external access for contractors and partners.',
      path: '/lms-aviation-companies',
    }
  ];

  const lmsCarouselImages = usePublicImages('lms', 'LMS interface screen');

  // Enhanced schema for SEO
  const schemaMarkup = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "AviaGov LMS – Governed Aviation Training Platform",
    "description": "Modular aviation training platform for course delivery, training governance, ATCO objective management, airline qualification workflows, and compliance-pack activation.",
    "url": "https://www.aviagov.aero/modules/lms",
    "applicationCategory": "BusinessApplication",
    "operatingSystem": "Web-based (SaaS)",
    "offers": {
      "@type": "Offer",
      "price": "Contact for pricing",
      "priceCurrency": "USD",
      "url": "https://www.aviagov.aero/contact"
    },
    "author": {
      "@type": "Organization",
      "name": "AviaGov",
      "url": "https://aviagov.aero"
    }
  };

  return (
    <div className="animate-fade-in-up">
      <SEO
        title="AviaGov LMS | Governed Aviation Training, Qualifications, and Compliance-Pack Activation"
        description="Modular aviation training platform for airlines, ANSPs, training organizations, operators, and authorities. Deliver courses, govern qualification records, manage recurrence, activate compliance packs, and run ATCO or airline-specialized workflows."
        ogType="product"
        faq={lmsFAQ}
        schema={schemaMarkup}
      />

      {/* Hero Section */}
      <section className="py-24 bg-gradient-to-b from-slate-950 to-slate-900 border-b border-white/5">
        <div className="max-w-7xl mx-auto px-4">
          <nav className="flex items-center space-x-2 text-slate-500 text-sm mb-6 uppercase tracking-widest">
            <span>Modules</span>
            <span>/</span>
            <span className="text-accent">LMS</span>
          </nav>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div>
              <h1 className="text-5xl lg:text-7xl font-bold font-heading mb-4 leading-tight">
                Govern aviation training <br />
                <span className="text-accent">from delivery to qualification decisions.</span>
              </h1>

              <p className="text-lg text-accent font-semibold mb-6">
                LMS delivery • Training governance • ATCO and airline specialization
              </p>

              <p className="text-xl text-slate-300 mb-6 leading-relaxed">
                AviaGov LMS is a modular regulated training platform for airlines, ANSPs, operators, training organizations, and authorities. It combines course delivery with governed qualification records, recurrence management, assessor authority controls, ATCO objective management, airline crew qualification workflows, and compliance-pack activation.
              </p>

              <p className="text-base text-slate-400 mb-8 leading-relaxed">
                Use the LMS layer for public or internal training delivery, then add governance, ATCO, and airline operations overlays where regulated record structures and operational review workflows are required.
              </p>

              {/* CTA Buttons */}
              <div className="flex flex-col sm:flex-row gap-4 mb-12">
                <a
                  href="/contact?product=lms"
                  className="px-8 py-4 bg-accent text-slate-950 font-bold rounded-lg hover:bg-accent/90 transition text-center"
                >
                  Request Demo
                </a>
                {/* <a
                  href="/lms-features"
                  className="px-8 py-4 border border-accent text-accent font-bold rounded-lg hover:bg-accent/10 transition text-center"
                >
                  View Full Features
                </a> */}
              </div>

              {/* Trust signals */}
              <div className="text-sm text-slate-500">
                <p className="mb-3 font-semibold">Built for regulated training operations:</p>
                <div className="flex flex-wrap gap-2">
                  {trustSignals.map((signal, i) => (
                    <span key={i} className="bg-white/5 border border-white/10 px-3 py-2 rounded">
                      {signal.icon} {signal.label}
                    </span>
                  ))}
                </div>
              </div>
            </div>

            {/* Right side: Metrics + Screenshot */}
            <div className="space-y-6">
              <div className="grid grid-cols-2 gap-4">
                {moduleData.metrics?.slice(0, 2).map((metric, i) => (
                  <div key={i} className="bg-white/5 border border-white/10 p-8 rounded-2xl text-center hover:bg-white/10 transition">
                    <div className="text-4xl font-bold text-accent mb-2">{metric.value}</div>
                    <p className="text-xs text-slate-400 uppercase">{metric.label}</p>
                  </div>
                ))}
              </div>

              <div className="relative p-1 bg-gradient-to-br from-slate-800 to-slate-700 rounded-2xl overflow-hidden border border-accent/20">
                <AIImage
                  src="/publicLms.png"
                  alt="AviaGov LMS dashboard showing governed aviation training, qualification tracking, and live session delivery"
                  className="w-full opacity-95 rounded-2xl"
                  aspectRatio="4:3"
                />
              </div>

              <div className="text-xs text-slate-500 text-center">
                LMS dashboard with governed training records, qualification oversight, and delivery analytics
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Product Layers */}
      <section className="py-24 px-4 bg-slate-950 border-b border-white/5">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-4xl font-bold font-heading mb-4 text-white">Modular regulated training stack</h2>
          <p className="text-slate-400 text-base mb-12 leading-relaxed">
            AviaGov is no longer positioned as a single undifferentiated LMS. The platform layers delivery, governance, and operational specialization so organizations can activate only the structures they need while retaining one governed training record model.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {productLayers.map((layer, i) => (
              <GlowCard key={i} delay={i * 100}>
                <h3 className="text-xl font-bold text-accent mb-3">{layer.title}</h3>
                <p className="text-slate-400 text-sm mb-6 leading-relaxed">{layer.description}</p>
                <ul className="space-y-2">
                  {layer.items.map((item, j) => (
                    <li key={j} className="text-slate-500 text-sm flex items-start">
                      <span className="text-accent mr-2">✓</span>
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </GlowCard>
            ))}
          </div>
        </div>
      </section>

      {/* How Training Works */}
      <section className="py-24 px-4 bg-slate-950/50 border-b border-white/5">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-4xl font-bold font-heading mb-6 text-white">How governed training works</h2>
          <p className="text-slate-400 text-base mb-12 leading-relaxed">
            The operating model starts with course delivery but does not stop there. Training evidence flows into qualification programs, recurrence rules, specialization overlays, decision controls, and export-ready records for regulated environments.
          </p>

          <div className="space-y-6 mb-12">
            {governedWorkflow.map((step, i) => (
              <div key={i} className="flex gap-6 p-6 border border-white/10 rounded-xl hover:border-accent/30 transition">
                <div className="flex-shrink-0 w-12 h-12 bg-accent/20 text-accent font-bold rounded-full flex items-center justify-center">
                  {step.num}
                </div>
                <div>
                  <h3 className="text-lg font-bold text-white mb-2">{step.title}</h3>
                  <p className="text-slate-400 text-sm">{step.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Image Carousel */}
      <ImageCarousel
        title="LMS Interface Preview"
        description="Explore course delivery, governed qualification tracking, live classroom workflows, and training record management views."
        images={lmsCarouselImages}
      />

      <section className="py-24 px-4 border-b border-white/5">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-4xl font-bold font-heading mb-6 text-white">Role-specific LMS deployments</h2>
          <p className="text-slate-400 text-base mb-12 leading-relaxed max-w-4xl">
            The LMS stack stays modular, but the operating model changes by organization. These pages show how AviaGov LMS is positioned for authority and ANSP environments, airline crew qualification operations, and broader regulated aviation companies.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {rolePages.map((page, i) => (
              <GlowCard key={page.path} delay={i * 100}>
                <h3 className="text-2xl font-bold text-white mb-4">{page.title}</h3>
                <p className="text-slate-400 text-sm leading-relaxed mb-8">{page.description}</p>
                <Link
                  to={page.path}
                  className="inline-flex px-6 py-3 border border-accent/30 text-accent font-bold rounded-lg hover:bg-accent/10 transition"
                >
                  Explore Page
                </Link>
              </GlowCard>
            ))}
          </div>
        </div>
      </section>

      <section className="py-24 px-4 bg-slate-950/50 border-b border-white/5">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-4xl font-bold font-heading mb-6 text-white">What&apos;s inside the LMS today</h2>
          <p className="text-slate-400 text-base mb-12 leading-relaxed max-w-4xl">
            The current LMS implementation is not limited to course delivery and certificates. The platform already includes concrete governance workspaces, delivery operations, analytics surfaces, assessment tooling, live orchestration, and integration layers that support regulated training at operational scale.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {whatsInside.map((item, i) => (
              <GlowCard key={item.title} delay={i * 100}>
                <h3 className="text-xl font-bold text-white mb-4">{item.title}</h3>
                <p className="text-slate-400 text-sm leading-relaxed">{item.description}</p>
              </GlowCard>
            ))}
          </div>
        </div>
      </section>

      {/* Airline Operations Training */}
      <section className="py-24 px-4 border-b border-white/5">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-4xl font-bold font-heading mb-6 text-white">Airline operations training</h2>
          <p className="text-slate-400 text-base mb-12 leading-relaxed max-w-4xl">
            Airline training in AviaGov is designed around governed crew qualification workflows, not only course completion. The product can hold operational crew records, ingest external provider activity, route evidence into qualification records, and support controlled check-event finalization and recurrence monitoring.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {airlineWorkflows.map((workflow, i) => (
              <GlowCard key={i} delay={i * 100}>
                <h3 className="text-xl font-bold text-white mb-4">{workflow.title}</h3>
                <p className="text-slate-400 text-sm leading-relaxed">{workflow.description}</p>
              </GlowCard>
            ))}
          </div>
        </div>
      </section>

      {/* ATCO Objectives */}
      <section className="py-24 px-4 bg-slate-950/50 border-b border-white/5">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-4xl font-bold font-heading mb-6 text-white">ATCO and regulated objective management</h2>
          <p className="text-slate-400 text-base mb-10 leading-relaxed max-w-4xl">
            For ATCO and other objective-driven environments, AviaGov adds framework-driven objective structures on top of the LMS and governance layers. Objective catalogs, mappings, and evidence-aware evaluation allow organizations to connect training activity with governed qualification outcomes.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {atcoCapabilities.map((capability, i) => (
              <div key={i} className="p-6 border border-white/10 rounded-xl">
                <p className="text-slate-300 text-sm flex items-start gap-3">
                  <span className="text-accent mt-1">✓</span>
                  <span>{capability}</span>
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Compliance Packs */}
      <section className="py-24 px-4 bg-slate-950/50 border-b border-white/5">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-4xl font-bold font-heading mb-6 text-white">Compliance-pack activation</h2>
          <p className="text-slate-400 text-base mb-12 leading-relaxed max-w-4xl">
            Compliance packs in AviaGov act as seeded overlays. They activate governance presets, qualification structures, export profiles, and specialization scaffolding that help organizations structure regulated training deployments without claiming finished regulator-signed jurisdiction coverage.
          </p>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            <GlowCard>
              <h3 className="text-xl font-bold text-white mb-6">Current seeded overlays</h3>
              <ul className="space-y-3">
                {compliancePacks.map((pack, i) => (
                  <li key={i} className="text-slate-300 text-sm flex items-start gap-3">
                    <span className="text-accent mt-1">✓</span>
                    <span>{pack}</span>
                  </li>
                ))}
              </ul>
            </GlowCard>

            <GlowCard>
              <h3 className="text-xl font-bold text-white mb-6">What activation means</h3>
              <ul className="space-y-3">
                {[
                  "Seed governance presets for qualification programs and recurrence handling",
                  "Activate export-ready record structures and profile scaffolding",
                  "Provide a structured baseline for airline or ATCO specialization",
                  "Support implementation and review without claiming out-of-the-box regulatory sign-off"
                ].map((item, i) => (
                  <li key={i} className="text-slate-300 text-sm flex items-start gap-3">
                    <span className="text-accent mt-1">✓</span>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </GlowCard>
          </div>
        </div>
      </section>

      {/* Public Portal Section */}
      <section className="py-24 px-4 border-b border-white/5">
        <GlowCard className="max-w-7xl mx-auto">
          <div className="flex flex-col md:flex-row gap-12 items-center">
            <div className="flex-1">
              <h2 className="text-3xl font-bold font-heading mb-6 text-white">
                Public portal and training delivery
              </h2>
              <p className="text-slate-400 text-base mb-6 leading-relaxed">
                AviaGov still supports strong core LMS delivery. Organizations can run branded internal or public-facing training under their own domain while keeping the larger governance model intact.
              </p>
              <ul className="space-y-3 text-slate-400 mb-6">
                <li className="flex items-start gap-3">
                  <span className="text-accent font-bold">✓</span>
                  <span>Public portal under customer domain with catalog, enrollment, and learner access</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-accent font-bold">✓</span>
                  <span>Course delivery across lessons, assessments, certificates, and live sessions</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-accent font-bold">✓</span>
                  <span>Analytics, learner risk views, and training visibility linked back to governed records</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-accent font-bold">✓</span>
                  <span>SMS-linked training workflows where training actions need to connect to broader operational oversight</span>
                </li>
              </ul>
              <p className="text-slate-500 text-sm">
                Access rules, certificates, portal visibility, and record structures remain under organizational control. AviaGov does not position the portal as a separate consumer marketplace.
              </p>
            </div>
          </div>
        </GlowCard>
      </section>

      <section className="py-24 px-4 bg-slate-950/50 border-b border-white/5">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-4xl font-bold font-heading mb-6 text-white">Delivery and assessment depth</h2>
          <p className="text-slate-400 text-base mb-10 leading-relaxed max-w-4xl">
            AviaGov also goes deeper than a basic aviation course platform in the day-to-day delivery stack. Assessment operations, segment-aware runs, live delivery, and compliance authoring all sit inside the same governed environment.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {deliveryDepth.map((item, i) => (
              <div key={i} className="p-6 border border-white/10 rounded-xl">
                <p className="text-slate-300 text-sm flex items-start gap-3">
                  <span className="text-accent mt-1">✓</span>
                  <span>{item}</span>
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <FAQSection items={lmsFAQ} title="Governed Aviation Training FAQ" />

      {/* Final CTA Section */}
      <section className="py-24 px-4 bg-gradient-to-r from-accent/10 to-accent/5 border-t border-accent/20">
        <div className="max-w-7xl mx-auto text-center">
          <h2 className="text-4xl font-bold font-heading mb-6 text-white">
            Build regulated training operations on a governed platform
          </h2>
          <p className="text-xl text-slate-400 mb-12 max-w-3xl mx-auto">
            AviaGov LMS is designed for airlines, ANSPs, operators, training organizations, and authorities that need course delivery, qualification governance, recurrence management, and export-ready training records in one controlled system.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="/contact?product=lms"
              className="px-8 py-4 bg-accent text-slate-950 font-bold rounded-lg hover:bg-accent/90 transition text-center"
            >
              Request a Demo
            </a>
            <a
              href="/pricing"
              className="px-8 py-4 border border-accent text-accent font-bold rounded-lg hover:bg-accent/10 transition text-center"
            >
              View Pricing
            </a>
            <a
              href="tel:+447456456668"
              className="px-8 py-4 border border-slate-500 text-slate-400 font-bold rounded-lg hover:border-accent hover:text-accent transition text-center"
            >
              Call Sales
            </a>
          </div>

          <p className="text-sm text-slate-500 mt-8">
            Discuss deployment scope, compliance-pack activation, specialization layers, and rollout requirements with the AviaGov team.
          </p>
        </div>
      </section>
    </div>
  );
};

export default LMSPage;
